module.exports = __webpack_public_path__ + "img/Unicom-7.d5213a4b.svg";